// Re-use the canonical axios instance (auth token + 401 handling already configured)
import api from "../api/axiosConfig";

// Organization API
export const organizationAPI = {
  getAll: () => api.get("/organizations"),
  getById: (id) => api.get(`/organizations/${id}`),
  create: (data) => api.post("/organizations", data),
  update: (id, data) => api.put(`/organizations/${id}`, data),
  delete: (id) => api.delete(`/organizations/${id}`),
};

// Branch API
export const branchAPI = {
  getAll: () => api.get("/branches"),
  getById: (id) => api.get(`/branches/${id}`),
  getByOrganization: (orgId) => api.get(`/branches/organization/${orgId}`),
  create: (data) => api.post("/branches", data),
  update: (id, data) => api.put(`/branches/${id}`, data),
  delete: (id) => api.delete(`/branches/${id}`),
};

// Department API
export const departmentAPI = {
  getAll: () => api.get("/departments"),
  getById: (id) => api.get(`/departments/${id}`),
  getByOrganization: (orgId) => api.get(`/departments/organization/${orgId}`),
  getByBranch: (branchId) => api.get(`/departments/branch/${branchId}`),
  create: (data) => api.post("/departments", data),
  update: (id, data) => api.put(`/departments/${id}`, data),
  delete: (id) => api.delete(`/departments/${id}`),

  // Sub-department functions
  getSubdepartments: (departmentId) =>
    api.get(`/departments/${departmentId}/subdepartments`),
  createSubdepartment: (departmentId, data) =>
    api.post(`/departments/${departmentId}/subdepartments`, data),
  updateSubdepartment: (departmentId, subdepartmentId, data) =>
    api.put(
      `/departments/${departmentId}/subdepartments/${subdepartmentId}`,
      data
    ),
  deleteSubdepartment: (departmentId, subdepartmentId) =>
    api.delete(
      `/departments/${departmentId}/subdepartments/${subdepartmentId}`
    ),
};

// User API (backend: /api/profile/users*)
// There is no GET /profile/users/:id and no GET by department, so those
// calls are not exposed.
export const userAPI = {
  getAll: () => api.get("/profile/users"),
  getByBranch: (branchId) => api.get(`/profile/users/branch/${branchId}`),
  getByOrganization: (orgId) => api.get(`/profile/users/organization/${orgId}`),
  create: (data) => api.post("/profile/users", data),
  update: (id, data) => api.put(`/profile/users/${id}`, data),
  // Soft delete on the server: deactivates, hides and signs the user out.
  delete: (id) => api.delete(`/profile/users/${id}`),
  updateRole: (id, role) => api.put(`/profile/users/${id}`, { role }),
  updateStatus: (id, status) => api.put(`/profile/users/${id}`, { status }),
};

export default api;
